import { PegProduct } from "@CommonTypes/merchflow/pog/pegboard";
import { Color } from "src/elements";

/**
 * Maps a pegboard facing's update `changeType` (from the update API response) to the badge
 * color used to flag how that facing changed. Returns `null` for unchanged/unknown facings so
 * callers can skip the badge entirely.
 */
export const getPegboardFacingChangeColor = (pegProduct: PegProduct): string | null => {
  switch (pegProduct.updateStatus?.changeType) {
    case "INSERTED":
      return Color.emerald500;
    case "SWAPPED_IN":
      return Color.paletteSkyBlue;
    case "FACINGS_INCREASED":
      return Color.paletteTeal;
    case "FACINGS_DECREASED":
      return Color.amber;
    case "SWAPPED_OUT":
    case "DELETED":
      return Color.paletteRed;
    default:
      return null;
  }
};

export type PegboardFacingChangeLabelKey =
  | "pegboardFacingChange.inserted"
  | "pegboardFacingChange.swappedIn"
  | "pegboardFacingChange.facingsIncreased"
  | "pegboardFacingChange.facingsDecreased"
  | "pegboardFacingChange.swappedOut"
  | "pegboardFacingChange.deleted";

export const getPegboardFacingChangeLabelKey = (
  changeType?: string,
): PegboardFacingChangeLabelKey | null => {
  switch (changeType) {
    case "INSERTED":
      return "pegboardFacingChange.inserted";
    case "SWAPPED_IN":
      return "pegboardFacingChange.swappedIn";
    case "FACINGS_INCREASED":
      return "pegboardFacingChange.facingsIncreased";
    case "FACINGS_DECREASED":
      return "pegboardFacingChange.facingsDecreased";
    case "SWAPPED_OUT":
      return "pegboardFacingChange.swappedOut";
    case "DELETED":
      return "pegboardFacingChange.deleted";
    default:
      return null;
  }
};
